import { render, staticRenderFns } from "./ExamStudents.vue?vue&type=template&id=3e804332&scoped=true&"
import script from "./ExamStudents.vue?vue&type=script&lang=ts&"
export * from "./ExamStudents.vue?vue&type=script&lang=ts&"
import style0 from "./ExamStudents.vue?vue&type=style&index=0&id=3e804332&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e804332",
  null
  
)

export default component.exports